import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgIf } from '@angular/common';
import { tap } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateModule } from '@ngx-translate/core';
import { TariffService } from '../../../../../core/services/tariff.service';
import { Tariff, TariffsSearchParams } from '../../../../tariffs/tariff.model';
import { ModalService } from '../../../../../core/modal/modal.service';
import { MetricsService } from '../../../../../shared/metrics/metrics.service';
import { SelectTariffProcessFields } from '../../../sign-selected-tariff-page/sign-selected-tariff-page.model';
import { TariffFormModel } from '../../../../tariffs/select-tariff-connection/select-tariff-connection.types';
import { ModalModule } from '../../../../../core/modal/modal.module';
import { TariffsModule } from '../../../../tariffs/tariffs.module';
import { UniqueTariffsPipe } from '../../../shared/pipes/unique-tariffs.pipe';

export interface SelectTariffModalResult extends Tariff {
  consultantPhone: string | null;
  promoCode?: string;
  simNumber: string;
}

@UntilDestroy()
@Component({
  selector: 'tax-select-tariff-modal',
  templateUrl: 'select-tariff-modal.component.html',
  styleUrls: ['select-tariff-modal.component.sass'],
  standalone: true,
  imports: [
    ModalModule,
    TariffsModule,
    UniqueTariffsPipe,
    NgIf,
    TranslateModule,
  ],
})
export class SelectTariffModalComponent implements OnInit {
  @Input() kkmProcessFields?: SelectTariffProcessFields;
  @Input() searchParams: TariffsSearchParams = {
    kkmModel: '',
    kkmSerial: '',
  };

  tariffForm?: FormGroup<TariffFormModel>;
  tariffs: Tariff[] = [];
  selectedTariff?: Tariff;

  private allTariffs: Tariff[] = [];

  constructor(
    private tariffService: TariffService,
    private metricsService: MetricsService,
    private modalService: ModalService,
  ) {}

  ngOnInit(): void {
    this.setTariffs();
  }

  back(): void {
    this.selectedTariff = undefined;
  }

  returnSelectedTariff(): void {
    if (!this.selectedTariff || !this.tariffForm?.value.connectionType) {
      return;
    }

    const selectedTariff = this.tariffService.getTariffsByParams(this.allTariffs, {
      connectionType: this.tariffForm.value.connectionType,
      periodPrice: this.selectedTariff.periodPrice,
      periodUnit: this.selectedTariff.periodUnit,
    })?.[0];
    this.metricsService.ymGoal(`Выбран тариф ${selectedTariff?.id}(${selectedTariff?.connectionType.connection}/${selectedTariff?.periodUnitsCount})`);

    this.modalService.close({
      ...this.tariffForm?.value,
      ...selectedTariff,
    });
  }

  selectTariff(tariff: Tariff): void {
    this.selectedTariff = tariff;
  }

  updateFormState(tariffForm: FormGroup<TariffFormModel>): void {
    this.tariffForm = tariffForm;
  }

  private setTariffs(): void {
    this.tariffService.getPublicTariffsByParams(this.searchParams)
      .pipe(
        tap((tariffs) => {
          this.allTariffs = tariffs;
        }),
        untilDestroyed(this),
      )
      .subscribe((tariffs) => {
        this.tariffs = tariffs;
      });
  }
}
